import { Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import cx from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './PeriodsHeader.module.scss';
import { FormattedMessage } from 'react-intl';

import PeriodSelector, {
  type PeriodSelectorProps,
} from 'Components/PeriodSelector/PeriodSelector';

type PeriodsProps = {
  hidePeriods?: boolean;
  hideNavigation?: boolean;
} & PeriodSelectorProps;

const PeriodsHeader = (props: PeriodsProps) => {
  const navigate = useNavigate();

  return (
    <div
      className={cx(classes.root, props.compact ? classes.compactRoot : null)}
    >
      <div
        className={cx(
          classes.periods,
          props.compact ? classes.compactPeriods : null
        )}
      >
        {!props.hideNavigation && (
          <Button variant="text" onClick={() => navigate('/dashboard')}>
            <ChevronLeftIcon className={classes.icon} />
            <span>
              <FormattedMessage id="back.to.dashboard" />
            </span>
          </Button>
        )}

        <div style={{ margin: '0 auto' }} />

        {!props.hidePeriods && (
          <div
            className={cx(
              classes.rangeColumn,
              props.compact ? classes.compactRangeColumn : null
            )}
          >
            <PeriodSelector {...props} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PeriodsHeader;
